import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { linhaService, Linha } from '../../services/linha';

interface SelectLinhaProps {
  value?: number;
  onChange: (value: number) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const SelectLinha: React.FC<SelectLinhaProps> = ({
  value,
  onChange,
  label = 'Linha',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
}) => {
  const { data: linhas = [], isLoading } = useQuery({
    queryKey: ['linhas'],
    queryFn: linhaService.getAll,
  });

  const handleChange = (event: any) => {
    onChange(Number(event.target.value));
  };

  return (
    <FormControl fullWidth={fullWidth} required={required} error={error} disabled={disabled}>
      <InputLabel id="linha-label">{label}</InputLabel>
      <Select
        labelId="linha-label"
        value={value || ''}
        onChange={handleChange}
        label={label}
        disabled={isLoading || disabled}
      >
        {linhas.map((linha) => (
          <MenuItem key={linha.id} value={linha.id}>
            {linha.nome}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectLinha;
